import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, PaginationNumberOfPagesSelect } from 'src/app/models/pagination.model';
import { PaginationService } from 'src/app/services/pagination.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent {
  

  subscriptions: Subscription = new Subscription();
  from: number;
  to: number;
  total: number;
  selectPage: number;
  countPage: number;
  _pageData: PaginationInput;
  pages: any = [];
  currentPage: number = 1;
  numberOfPagesSelect: PaginationNumberOfPagesSelect[] = [
    {value: 10, default: false},
    {value: 25, default: false},
    {value: 50, default: false},
    {value: 100, default: false},
  ];
  defaultItem: 10;

  form: UntypedFormGroup = this.fb.group({
    selectPage: [''],
    defaultItem: ['']
  })

  @Input() set pageData(value: PaginationInput){
    
    if(value){

      this._pageData = value;
      this.setDefaultValue();
      this.setData();
      this.numberPage();
    }
  }
  

  @Output() pageEvent: EventEmitter<PaginationPageEvent> = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private paginationService: PaginationService
  ) {}


  ngOnInit(): void {
    
    this.subscriptions.add(
      this.paginationService.listenerPaginationData().subscribe(val => {

        if (val) {
          
          this._pageData = val;
          this.setDefaultValue();
          this.setData();
          this.numberPage();

          this.form.get('defaultItem').setValue(10)
          
        }
      })
    );
   

  }

  getSelectPage(): any {

    let selectedPage  = this.form.get('selectPage').value;
    
    if (selectedPage <= this._pageData.numberOfPages + 1) {

      this.pageEvent.emit({ pageNumber: selectedPage, pageSize: this.getDefaultValue() });

      // this.paginationService.setPaginationListData({ pageNumber: selectedPage, pageSize: this.getDefaultValue() });


    }

  }

  numberPage() {

    if (this._pageData) {
      let pagesAmount = Math.ceil(this._pageData.count / this._pageData.size);     
      this.pages = new Array(pagesAmount);
    }
  }

  /**
   * 
   */
  setData():void {
    
    if(this._pageData){

      if(this._pageData.currentPage < this._pageData.numberOfPages){

        this.from = ((this._pageData.currentPage * this._pageData.size) - this._pageData.size) + 1;
        this.to = this._pageData.currentPage * this._pageData.size;
      }

      if(this._pageData.currentPage == this._pageData.numberOfPages){

        if((this._pageData.count % this._pageData.size) == 0){

          this.from = (this._pageData.count - this._pageData.size) + 1;
        }
        else{

          this.from = (this._pageData.count - (this._pageData.count % this._pageData.size)) + 1;
        }

        this.to = this._pageData.count;
      }

      this.total = this._pageData.count;
    }
  }


  /**
   * 
   * @param val 
   */
  navPage(val: string, page: number): void {

    if(val == 'prev' && this._pageData.currentPage > 1){

      this.pageEvent.emit({ pageNumber: (this._pageData.currentPage - 1), pageSize: this.getDefaultValue() });
      // this.paginationService.setPaginationListData({ pageNumber: (this._pageData.currentPage - 1), pageSize: this.getDefaultValue() });
    }

    if(val == 'next' && this._pageData.currentPage < this._pageData.numberOfPages){

      this.pageEvent.emit({ pageNumber: (this._pageData.currentPage + 1), pageSize: this.getDefaultValue() });
      // this.paginationService.setPaginationListData({ pageNumber: (this._pageData.currentPage + 1), pageSize: this.getDefaultValue() });
    }

    if(val == 'selectPage'){

      console.log("selectPage :", page);
      

      this.pageEvent.emit({ pageNumber: page, pageSize: this.getDefaultValue() });
      // this.paginationService.setPaginationListData({ pageNumber: page, pageSize: this.getDefaultValue() });
    }
  }


  /**
   * 
   */
  firstPage(): void {

    this.pageEvent.emit({ pageNumber: 1, pageSize: this.getDefaultValue() });
  }


  /**
   * 
   */
  setDefaultValue(): void {

    let check: boolean = false;
    
    for(let item of this.numberOfPagesSelect){

      if(item.value == this._pageData.size){

        item.default = true;
        check = true;
        break;
      }
      else{

        item.default = false;
      }
    }

    if(!check){

      this.numberOfPagesSelect[0].default = true;
    }
  }


  /**
   * 
   */
  getDefaultValue(): number {

    let num: PaginationNumberOfPagesSelect[] = this.numberOfPagesSelect.filter(val => val.default == true);
    
    if(num.length > 0){

      return num[0].value;
    }

    return 10;
  }


  /**
   * 
   * @param value 
   */
  selectDefaultValue(value: number): void {

    this._pageData.size = value;
    this.setDefaultValue();
    this.firstPage();
  }
}
